<template>
  <div
    class="v2-drag-drop"
    :class="{ 'v2-drag-drop--active': isDragging }"
    @drop.prevent="handleDrop"
    @dragover.prevent="handleDragOver"
    @dragleave="handleDragLeave"
  >
    <svg
      width="32"
      height="32"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
      class="v2-drag-drop__icon"
    >
      <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
      <polyline points="17 8 12 3 7 8" />
      <line
        x1="12"
        y1="3"
        x2="12"
        y2="15"
      />
    </svg>
    <p class="v2-drag-drop__text">
      Drag & Drop Image Here
      <br>or
    </p>
    <button
      class="v2-drag-drop__browse-btn"
      type="button"
      @click="$emit('browse-image')"
    >
      Browse Image
    </button>
  </div>
</template>

<script>
export default {
  name: 'V2DragAndDrop',
  data() {
    return {
      isDragging: false,
    }
  },
  methods: {
    handleDrop(event) {
      this.$emit('drop', event.dataTransfer.files)
      this.isDragging = false
    },
    handleDragOver() {
      this.isDragging = true
    },
    handleDragLeave() {
      this.isDragging = false
    },
  },
}
</script>

<style lang="scss" scoped>
.v2-drag-drop {
  margin-top: var(--v2-space-2);
  border: 2px dashed var(--v2-border);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 160px;
  border-radius: var(--v2-radius-lg);
  gap: var(--v2-space-2);
  transition: all 0.2s ease;
  cursor: pointer;

  &:hover {
    border-color: var(--v2-primary);
    background: rgba(116, 125, 238, 0.03);
  }

  &--active {
    border-color: var(--v2-success);
    background: rgba(16, 185, 129, 0.05);
  }

  &__icon {
    color: var(--v2-muted-foreground);
  }

  &__text {
    color: var(--v2-muted-foreground);
    font-size: 0.8125rem;
    text-align: center;
    margin: 0;
    line-height: 1.4;
  }

  &__browse-btn {
    padding: var(--v2-space-1) var(--v2-space-3);
    background: var(--v2-muted-foreground);
    color: #fff;
    border: none;
    border-radius: var(--v2-radius-sm);
    font-size: 0.75rem;
    font-weight: 500;
    font-family: var(--v2-font-sans);
    cursor: pointer;
    transition: background 0.15s ease;

    &:hover {
      background: var(--v2-foreground);
    }
  }
}
</style>
